<template>
  <el-form-item
    v-if="cardPaymentModeId === cardPaymentModeIds.youZan"
    label="有赞券码"
    prop="you_zan_number"
    :error="error"
  >
    <el-input
      :class="inputClass"
      v-model="valueBackUp"
      @input="handleChange"
      :disabled="isSearching"
      maxlength="20"
      show-word-limit
      clearable
      placeholder="请输入有赞券码"
    />
  </el-form-item>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCardIdByYouZanNumber } from '@/api/card';
import cardPaymentModeIds from '@/enums/cardPaymentModeIds';

export default {
  props: {
    value: String,
    width: {
      type: String,
      default: '',
    },
    inputClass: String,
    cardPaymentModeId: {
      type: [String, Number],
      default: 0,
    },
    excludeCardId: Number,
    excludeTrialPaymentId: Number,
  },
  data: () => ({
    cardPaymentModeIds,
    valueBackUp: '',
    list: [],
    error: '',
    isSearching: false,
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackUp) this.valueBackUp = value || '';
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp !== this.value) this.$emit('input', valueBackUp);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    async handleChange(you_zan_number) {
      if (this.error) this.error = '';
      if (this.isSearching) return;
      if (you_zan_number.length !== 11 && you_zan_number.length !== 12) return;

      this.isSearching = true;
      const { isError, data } = await getCardIdByYouZanNumber({
        you_zan_number,
        exclude_card_id: this.excludeCardId,
        exclude_trial_payment_id: this.excludeTrialPaymentId,
      });
      this.isSearching = false;
      if (isError) return;

      if (data.id) {
        this.error = '';
        this.$nextTick(() => {
          this.error = '该有赞券码已被核销，请输入其他券码！';
        });
      }
      if (data.actual_payment) this.$emit('actualPaymentChange', data.actual_payment);
    }
  },
  beforeMount() {
    this.valueBackUp = this.value || '';
  },
};
</script>
